/**
 * @generated SignedSource<<11940ca7797b2bf6079fd3d2b2dc825a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InsertUserActionInput = {
  userAction: UserActionInput;
};
export type UserActionInput = {
  actionTypeId: string;
  assessmentSessionId?: any | null | undefined;
  classId?: string | null | undefined;
  description: string;
  diagnosticSessionId?: any | null | undefined;
  exitSlipSessionId?: any | null | undefined;
  learnosityExitSlipSessionIdRaw?: any | null | undefined;
  learnositySessionSessionIdRaw?: any | null | undefined;
  lessonId?: string | null | undefined;
  practiceProblemsSessionId?: any | null | undefined;
  skillId?: string | null | undefined;
  timeStamp: any;
  userId: string;
};
export type SkillResourceCreateTimelineEventMutation$variables = {
  input: InsertUserActionInput;
};
export type SkillResourceCreateTimelineEventMutation$data = {
  readonly insertUserAction: {
    readonly errors: ReadonlyArray<{
      readonly __typename?: string;
      readonly message?: string;
    }> | null | undefined;
    readonly userActionNode: {
      readonly description: string;
      readonly id: string;
      readonly lesson: {
        readonly id: string;
        readonly isActive: boolean;
      } | null | undefined;
      readonly skill: {
        readonly code: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly user: {
        readonly id: string;
        readonly isActive: boolean;
        readonly publicUserId: string | null | undefined;
      };
    } | null | undefined;
  };
};
export type SkillResourceCreateTimelineEventMutation = {
  response: SkillResourceCreateTimelineEventMutation$data;
  variables: SkillResourceCreateTimelineEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "UserActionNode",
  "kind": "LinkedField",
  "name": "userActionNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNode",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicUserId",
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillNode",
      "kind": "LinkedField",
      "name": "skill",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LessonNode",
      "kind": "LinkedField",
      "name": "lesson",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillResourceCreateTimelineEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InsertUserActionPayload",
        "kind": "LinkedField",
        "name": "insertUserAction",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "type": "Error",
                "abstractKey": "__isError"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SkillResourceCreateTimelineEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InsertUserActionPayload",
        "kind": "LinkedField",
        "name": "insertUserAction",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Error",
                "abstractKey": "__isError"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "00f3a94fd24c7f6e3a91109004698d77",
    "id": null,
    "metadata": {},
    "name": "SkillResourceCreateTimelineEventMutation",
    "operationKind": "mutation",
    "text": "mutation SkillResourceCreateTimelineEventMutation(\n  $input: InsertUserActionInput!\n) {\n  insertUserAction(input: $input) {\n    userActionNode {\n      id\n      description\n      user {\n        id\n        publicUserId\n        isActive\n      }\n      skill {\n        id\n        name\n        code\n      }\n      lesson {\n        id\n        isActive\n      }\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fca507b6c91af28cef30ff016f99dbbf";

export default node;
